
import { defaultIconColor, defaultIconSize, IIcon } from "./settings"


export const DownloadIcon = (props: IIcon) => {

    return (
        <svg
            width={props.width ? props.width : defaultIconSize.width}
            height={props.height ? props.height : defaultIconSize.height}
            viewBox="0 0 34 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
        <path d="M15.9707 3L16.1011 23.1739" stroke={props.color || defaultIconColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M26.1445 25L6.97062 25" stroke={props.color || defaultIconColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.708 16.9978L16.1016 23.6043L9.49509 16.9978" stroke={props.color || defaultIconColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
